import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Container as ContainerComponent } from '@presentation/components';
import type { MediaQueryBreakpoint } from '@presentation/styles';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';
import { InputWrapper } from '../InputWrapper';

const MOBILE_BREAKPOINT: MediaQueryBreakpoint = 'tablet';

export const HeaderSearchInputWrapper = styled(InputWrapper)<{ hasMobileWrap?: boolean }>`
  margin-bottom: 0px;

  &:not(:last-child) {
    margin-right: 15px;
  }

  ${(props) =>
    props.hasMobileWrap &&
    css`
      ${mediaQuery(MOBILE_BREAKPOINT)} {
        margin-right: 0 !important;
        width: 100%;

        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    `}
`;

export const Banner = styled.div<{ src?: string; hasChildren: boolean }>`
  position: relative;
  text-align: center;
  padding: 35px 0 ${(props) => (props.hasChildren ? '90px' : '35px')};
  background-color: ${(props) => props.theme.color.blue.lightBlue};
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: cente;
  align-items: center;

  ${(props) =>
    props.src &&
    `
  background: url(${props.src}) no-repeat center center;
  background-size: cover;

  &::after {
    content: ""; 
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: rgba(0, 0, 0, 0.3);
  }
  `}
`;

export const Title = styled.h1<{ titleColor?: 'blue' | 'white' }>`
  z-index: 1;
  position: relative;
  text-align: center;
  color: ${(props) =>
    props.titleColor === 'blue' ? props.theme.color.blue.default : props.theme.color.light.default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  margin-bottom: 8px;
  ${responsiveFontSize(44, 4)}
`;

export const Subtitle = styled.h2<{ titleColor?: 'blue' | 'white' }>`
  z-index: 1;
  position: relative;
  text-align: center;
  color: ${(props) =>
    props.titleColor === 'blue' ? props.theme.color.blue.default : props.theme.color.light.default};
  margin-bottom: 8px;
  font-weight: 400;
  ${responsiveFontSize(30, 4)}
`;

export const Container = styled(ContainerComponent)`
  margin-top: -60px;
  z-index: 2;
  position: relative;
`;

export const SearchWrapper = styled.div<{ hasMobileWrap?: boolean }>`
  border-radius: 10px;
  background: ${(props) => props.theme.color.light.default};
  color: ${(props) => props.theme.color.medium.default};
  box-shadow: 0 3px 8px 0 rgba(0, 0, 48, 0.18);
  padding: 30px 25px;
  margin-bottom: 20px;
  display: flex;

  ${mediaQuery('tablet')} {
    padding: 20px 15px;
  }

  ${(props) =>
    props.hasMobileWrap &&
    `
  ${mediaQuery(MOBILE_BREAKPOINT)} {
    flex-wrap: wrap;
  }
  `}
`;

export const DecorationImage = styled.img`
  position: absolute;
  right: 0px;
  top: 0;
  bottom: 0;
  top: 10px;
  right: 10px;
  height: 100%;
  ${mediaQuery('tablet')} {
    display: none;
  }
`;
